import React from 'react';

import { S3_BUCKET_URL } from '@/constants';
import { webCampaign } from '@/modules/webCampaign';
import { useLayoutSelections } from '@/pages/Onboarding/hooks/useLayoutSelections';
import {
  supportedSexyBodyShapes,
  supportedSexyHairColors,
} from '@/pages/Paywall/Variants/V6/constants';
import { preloadImage } from '@/utils/preloadImage';

export const useOwnAiPreloadImages = () => {
  const { ageGeneration, bodyShape, hairColor } = useLayoutSelections();

  React.useEffect(() => {
    let isPreloaded = false;

    if (
      webCampaign.setup.paywallNotes.includes('fixed-timer') ||
      webCampaign.setup.paywallNotes.includes('fixed-timer-second-plan')
    ) {
      preloadImage('../assets/paywall/bg-fixed-timer.png');
      isPreloaded = true;
    }

    if (webCampaign.setup.paywallImagesVariant === 'v6-sexy') {
      preloadImage(
        `${S3_BUCKET_URL}/paywall/v6-sexy/${ageGeneration}_${hairColor}_${bodyShape}.png`,
      );
      isPreloaded = true;
    }

    if (webCampaign.setup.paywallImagesVariant === 'skinny_regular_on_bed') {
      preloadImage(
        `${S3_BUCKET_URL}/paywall/fast-pay-tab/skinny_regular_on_bed/${ageGeneration}_${hairColor}_${bodyShape}.png`,
      );
      isPreloaded = true;
    }

    if (webCampaign.setup.paywallImagesVariant === 'one-night-stand') {
      preloadImage(`${S3_BUCKET_URL}/paywall/one-night-stand/paywall.png`);
      isPreloaded = true;
    }

    const isCrutchOnly4NsfwGirl =
      webCampaign.setup.paywallNotes.includes('4-nsfw-girl') &&
      hairColor &&
      supportedSexyHairColors.includes(hairColor) &&
      bodyShape &&
      supportedSexyBodyShapes.includes(bodyShape);

    if (isCrutchOnly4NsfwGirl) {
      preloadImage(
        `${S3_BUCKET_URL}/paywall/v6-sexy/${ageGeneration}_${hairColor}_${bodyShape}.png`,
      );
      isPreloaded = true;
    }

    if (!isPreloaded) {
      preloadImage(
        `${S3_BUCKET_URL}/paywall/v6/${ageGeneration}_${hairColor}_${bodyShape}.png`,
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
